import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subscription } from 'rxjs';
import { SelectWhsPopupService } from '../switch-whs-popup/services/select-whs-popup.service';
import { LoactionStripService } from './loaction-strip.service';

@Component({
    selector: 'app-location-strip',
    templateUrl: './location-strip.component.html',
    styleUrls: ['./location-strip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LocationStripComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  usergetDataObj: any;
  userAccountgetData: any;
  showLocStrip = false;
  isIndirectAccount: boolean | undefined;
  currentCustomer : Observable<any>
  constructor(
    private readonly locService: LoactionStripService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private readonly selectWhsPopupService: SelectWhsPopupService,
    private readonly windowRef: WindowRef,
  ) {
    this.currentCustomer = this.user.get();
  }

  getUserAccountData(userId: any): void {
    this.locService.getUserAccountDataFromDb(userId);
    this.subscription.add(
      this.locService.userAccountData.subscribe((userData) => {
        if (userData) {
          this.usergetDataObj = userData;
          this.ref.detectChanges();
        }
      })
    );

    this.subscription.add(
      this.selectWhsPopupService.enableParent$.subscribe((isEnabled) => {
        if (isEnabled !== null && isEnabled !== undefined) {
          this.showLocStrip = isEnabled;
          this.ref.detectChanges();
        }
      })
    );
  }

  ngOnInit() {
    this.subscription.add(
      this.user.get().subscribe((res:any) => {
        if (res) {
          this.userAccountgetData = res;
          this.showLocStrip = true;
          this.getUserAccountData(this.userAccountgetData.userName);
          this.isIndirectAccount = res.accountType === 'INDIRECT';
        } else {
          this.showLocStrip = false;
          this.locService.reset();
        }
        this.ref.detectChanges();
      })
    );
   
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
